import styled from 'styled-components';

export default styled.p`
  text-align: left;
  font-size: 16px;
  line-height: 1.58;
  letter-spacing: -0.003em;
  color: #555555;
`;
